export default __webpack_public_path__ + "static/media/slide3.daf5d30c.svg";